const TerritoryNames = 
{
    AutonomousTerritory: "Autonomous Territory",
    DevelopedTerritory: "Developed Territory",
    HistoricTerritory: "Historic Territory",
    InhabitedTerritory: "Inhabited Territory",
    StrategicTerritory: "Strategic Territory",
    VastTerritory: "Vast Territory",
    WealthyTerritory: "Wealthy Territory"
}

module.exports = TerritoryNames